import React from "react";
import { buildRoutes } from "@app/routes/RouteBuilder";
import lazyWithRetry from "@shared/utils/lazyWithRetry";

// Lazy loading con retry automático
const DevHomeDashboard = lazyWithRetry(
  () => import("./ui/pages/DevHomeDashboard"),
  "DevHomeDashboard",
);
const RoleSelectorPage = lazyWithRetry(
  () => import("./ui/pages/RoleSelectorPage"),
  "RoleSelectorPage",
);
const TrelloTickets = lazyWithRetry(
  () => import("./ui/pages/TrelloTickets"),
  "TrelloTickets",
);
const AgentQualityDashboard = lazyWithRetry(
  () => import("./ui/pages/AgentQualityDashboard"),
  "AgentQualityDashboard",
);

/**
 * Rutas de herramientas de desarrollo
 */
const developerToolsRoutes = buildRoutes([
  {
    path: "/homedeveloper",
    element: DevHomeDashboard,
    roles: [5],
  },
  {
    path: "/homedeveloper/roles",
    element: RoleSelectorPage,
    roles: [5],
  },
  {
    path: "/homedeveloper/tickets",
    element: TrelloTickets,
    roles: [5],
  },
  {
    path: "/homedeveloper/agent-quality",
    element: AgentQualityDashboard,
    roles: [5],
  },
]);

export default developerToolsRoutes;
